/**
 * Hamburger Menu Fix
 * Ensures the hamburger menu works properly with correct animations
 */

document.addEventListener('DOMContentLoaded', function() {
    // Get hamburger menu elements
    const hamburgerButton = document.querySelector('[data-hamburger-menu]');
    const hamburgerMenu = document.querySelector('[data-hamburger-body]');
    const closeButtons = document.querySelectorAll('[data-hamburger-menu-close]');
    const menuItems = document.querySelectorAll('[data-menu-items]');
    
    if (!hamburgerButton || !hamburgerMenu) {
        console.warn('Hamburger menu elements not found');
        return;
    }
    
    // Function to open menu
    function openMenu() {
        hamburgerMenu.style.display = 'block';
        hamburgerButton.classList.add('active');
        document.body.classList.add('hamburger-open', 'no-scroll');
        
        // Add visible class after a small delay for animation
        setTimeout(() => {
            hamburgerMenu.classList.add('is-visible', 'active');
        }, 10);
        
        // Animate menu items
        menuItems.forEach((item, index) => {
            setTimeout(() => {
                item.classList.add('animation', 'animated');
            }, 100 * (index + 1));
        });
    }
    
    // Function to close menu
    function closeMenu() {
        hamburgerButton.classList.remove('active');
        hamburgerMenu.classList.remove('is-visible', 'active');
        document.body.classList.remove('hamburger-open', 'no-scroll');
        
        // Reset menu items animation
        menuItems.forEach(item => {
            item.classList.remove('animation', 'animated', 'active');
        });
        
        // Hide menu after animation completes
        setTimeout(() => {
            hamburgerMenu.style.display = 'none';
        }, 400);
    }
    
    // Toggle menu on hamburger button click
    hamburgerButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (hamburgerMenu.classList.contains('is-visible')) {
            closeMenu();
        } else {
            openMenu();
        }
    });
    
    // Close menu on close button click
    closeButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            closeMenu();
        });
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && hamburgerMenu.classList.contains('is-visible')) {
            closeMenu();
        }
    });
    
    // Handle submenu toggles
    const menuItemsWithDropdown = document.querySelectorAll('.menu-item.has-submenu, [data-has-submenu]');
    
    menuItemsWithDropdown.forEach(item => {
        const link = item.querySelector('.menu-item-link');
        if (link) {
            link.addEventListener('click', function(e) {
                // If it has a dropdown, prevent navigation and toggle dropdown
                if (item.querySelector('.dropdown-menus-main')) {
                    e.preventDefault();
                    item.classList.toggle('active');
                    
                    // Close other open dropdowns
                    menuItemsWithDropdown.forEach(otherItem => {
                        if (otherItem !== item && otherItem.classList.contains('active')) {
                            otherItem.classList.remove('active');
                        }
                    });
                }
            });
        }
    });
    
    // Add smooth scrolling for dropdown menus
    const dropdownMenus = document.querySelectorAll('.dropdown-menus-main');
    dropdownMenus.forEach(menu => {
        // Set initial max-height for animation
        if (!menu.style.maxHeight) {
            menu.style.maxHeight = '0px';
        }
    });
    
    // Update max-height on active class change
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const item = mutation.target;
                const dropdown = item.querySelector('.dropdown-menus-main');
                if (dropdown) {
                    if (item.classList.contains('active')) {
                        dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
                    } else {
                        dropdown.style.maxHeight = '0px';
                    }
                }
            }
        });
    });
    
    // Observe menu items for class changes
    menuItemsWithDropdown.forEach(item => {
        observer.observe(item, { attributes: true });
    });
});

// Reinitialize on Shopify section reload (for theme editor)
document.addEventListener('shopify:section:load', function() {
    // Re-run initialization
    const event = new Event('DOMContentLoaded');
    document.dispatchEvent(event);
});